import classNames from 'classnames';
import React from 'react';
import styles from './PlayPauseIcon.scss';
var PlayPauseIcon = function (_a) {
    var className = _a.className, isPlaying = _a.isPlaying;
    return (React.createElement("i", { role: "presentation", className: classNames(isPlaying ? styles.pause : styles.play, className) }));
};
export default PlayPauseIcon;
//# sourceMappingURL=PlayPauseIcon.js.map